exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-answer-review{border-radius:.3rem;background-color:#e1f6f2;padding:1em;margin-bottom:1em}.review-assessment{border-radius:.3rem;background-color:#f2f2f2;padding:1em}.card-date{color:rgba(0,0,0,.2);float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17cf7534","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/course/chapter/ChapterReview.vue
// module id = 260
// module chunks = 0